/** Nominal shift length — used for overtime display (beyond 9h). */
export const SHIFT_TARGET_HOURS = 9;

/** Full day when net working time is at least 8h 45m. */
export const FULL_DAY_MIN_HOURS = 8 + 45 / 60;

/** Half day when net working time is at least 4h but below 8h 45m. */
export const HALF_DAY_MIN_HOURS = 4;

export const FULL_DAY_MIN_LABEL = "8h 45m";
export const HALF_DAY_RANGE_LABEL = "4h–8h 44m";

export function isFullDayByPolicy(hours) {
  return hours >= FULL_DAY_MIN_HOURS;
}

export function isHalfDayByPolicy(hours) {
  return hours >= HALF_DAY_MIN_HOURS && hours < FULL_DAY_MIN_HOURS;
}

export function attendanceStatusLabel(hours) {
  if (isFullDayByPolicy(hours)) return "Present";
  if (isHalfDayByPolicy(hours)) return "Half-day";
  if (hours > 0) return "Short";
  return "Absent";
}
